import type { JSX } from 'react'

import { TokenPair } from '@repo/web3'

import { formatUint256 } from '@/lib/shared/utils/formatters'

interface TokenPairCellProps {
  collateralSymbol: string
  loanSymbol: string
}

export function TokenPairCell({ collateralSymbol, loanSymbol }: TokenPairCellProps): JSX.Element {
  return (
    <TokenPair
      loanToken={{ symbol: loanSymbol }}
      collateralToken={{ symbol: collateralSymbol }}
      variant="overlapping"
      size="sm"
    />
  )
}

interface TokenAmountCellProps {
  symbol: string
  amount: bigint
  decimals?: number
}

export function TokenAmountCell({ symbol, amount, decimals }: TokenAmountCellProps): JSX.Element {
  const formattedAmount = formatUint256(amount, decimals)
  return (
    <p
      className="overflow-hidden text-xs text-ellipsis whitespace-nowrap"
      title={`${formattedAmount} ${symbol}`}
    >
      {formattedAmount} {symbol}
    </p>
  )
}
